<ng-container
  *ngTemplateOutlet="isEditMode ? editMode : readMode"
></ng-container>

<ng-template #editMode>
  <form class="form" [formGroup]="form()">
    <markant-input
      class="input"
      data-cy="additional-org-data-master-kin-input"
      type="text"
      formControlName="masterKIN"
      [label]="'upgrade.pfa.wizard.section-1.form.masterKIN' | transloco"
      [showLabelHint]="true"
      [required]="true"
      [outlined]="true"
      [error]="
        masterKIN.errors
          | formControlError
            : showErrors() || masterKIN.touched || masterKIN.dirty
      "
      [errorText]="
        masterKIN.errors
          | formControlKeyError
            : 'upgrade.pfa.wizard.section-1.form.errors.masterKin'
            : showErrors() || masterKIN.touched || masterKIN.dirty
          | transloco
      "
    ></markant-input>

    <markant-input
      class="input"
      data-cy="additional-org-data-billing-email-input"
      type="text"
      formControlName="billingEmail"
      [label]="'upgrade.pfa.wizard.section-1.form.billingEmail' | transloco"
      [showLabelHint]="true"
      [required]="true"
      [outlined]="true"
      [error]="
        billingEmail.errors
          | formControlError
            : showErrors() || billingEmail.touched || billingEmail.dirty
      "
      [errorText]="
        billingEmail.errors
          | formControlKeyError
            : 'upgrade.pfa.wizard.section-1.form.errors'
            : showErrors() || billingEmail.touched || billingEmail.dirty
          | transloco
      "
    ></markant-input>

    <markant-select
      class="input"
      data-cy="additional-org-data-billing-language-input"
      formControlName="billingLanguage"
      [label]="'upgrade.pfa.wizard.section-1.form.bilingLanguage' | transloco"
      [showLabelHint]="true"
      [required]="true"
      [options]="billingLanguageOptions"
      [error]="
        billingLanguage.errors
          | formControlKeyError
            : 'upgrade.pfa.wizard.section-1.form.errors'
            : showErrors() || billingLanguage.touched || billingLanguage.dirty
          | transloco
      "
      [helper]="''"
    >
    </markant-select>
  </form>
</ng-template>

<!-- READ ONLY MODE -->
<ng-template #readMode>
  <section class="readonly">
    <section class="readonly-item">
      <label class="readonly-item-label">{{
        'upgrade.pfa.wizard.section-1.form.masterKIN' | transloco
      }}</label>
      {{ form().controls.masterKIN.value }}
    </section>
    <section class="readonly-item">
      <label class="readonly-item-label">{{
        'upgrade.pfa.wizard.section-1.form.billingEmail' | transloco
      }}</label>
      {{ form().controls.billingEmail.value }}
    </section>
    <section class="readonly-item">
      <label class="readonly-item-label">{{
        'upgrade.pfa.wizard.section-1.form.bilingLanguage' | transloco
      }}</label>
      {{ billingLanguageRecord[billingLanguageControlOnReadonly.value] }}
    </section>
  </section>
</ng-template>
